// Lightweight color parser/normalizer used by wiring hooks.
// Accepts numbers (0xRRGGBB) or strings like "#RRGGBB" or "#RRGGBBAA" or "rgba(r,g,b,a)".
// Returns { colorNumber: 0xRRGGBB, alpha: 0..1 }
export function parseColor(value) {
  if (value == null) return { colorNumber: 0x000000, alpha: 1 };

  // numeric input
  if (typeof value === 'number') {
    return { colorNumber: value >>> 0, alpha: 1 };
  }

  if (typeof value === 'string') {
    const s = value.trim();
    // hex formats
    if (s[0] === '#') {
      const hex = s.substring(1);
      if (hex.length === 6) {
        return { colorNumber: parseInt(hex, 16), alpha: 1 };
      }
      if (hex.length === 8) {
        const rgb = hex.substring(0, 6);
        const aa = hex.substring(6, 8);
        return { colorNumber: parseInt(rgb, 16), alpha: parseInt(aa, 16) / 255 };
      }
      // fallback: try parseInt
      const parsed = parseInt(hex, 16);
      if (!Number.isNaN(parsed)) return { colorNumber: parsed, alpha: 1 };
    }

    // rgba(...) or rgb(...)
    const rgbaMatch = s.match(/rgba?\s*\(([^)]+)\)/i);
    if (rgbaMatch) {
      const parts = rgbaMatch[1].split(',').map(p => p.trim());
      const r = parseInt(parts[0], 10) || 0;
      const g = parseInt(parts[1], 10) || 0;
      const b = parseInt(parts[2], 10) || 0;
      const a = parts[3] != null ? parseFloat(parts[3]) : 1;
      const colorNumber = ((r & 0xff) << 16) | ((g & 0xff) << 8) | (b & 0xff);
      return { colorNumber, alpha: Number.isFinite(a) ? a : 1 };
    }

    // last-resort: try converting as hex without '#'
    const parsed = parseInt(s, 16);
    if (!Number.isNaN(parsed)) return { colorNumber: parsed, alpha: 1 };
  }

  // If unsupported type, return black
  return { colorNumber: 0x000000, alpha: 1 };
}

export default parseColor;
